export const environment = {
  PRODUCTION: false,
  ENVIRONMENT: 'staging',
  PROJECT_SERVICE_BASE_URL: 'https://api.helix-gpo.com/api/v1/website/projects',
  TESTIMONIAL_SERVICE_BASE_URL:
    'https://api.helix-gpo.com/api/v1/website/testimonials',
};
